import { render } from "./VideoReceive.vue?vue&type=template&id=5230df83&scoped=true"
import script from "./VideoReceive.vue?vue&type=script&lang=js"
export * from "./VideoReceive.vue?vue&type=script&lang=js"

import "./VideoReceive.scss?vue&type=style&index=0&id=5230df83&lang=scss&scoped=true"

import exportComponent from "/home/viewchat/public_html/viewchat-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5230df83"]])

export default __exports__